const buildAlert = function (alertName, description) {
    return Object.freeze({[alertName]: description});
};

/**
 * Error objects formatted to be displayed in app error footer.
 * {
 *     [error-key]: error-description
 * }
 */
export const AppError = Object.freeze({
    LOGIN_FAILED: buildAlert(
        'LOGIN_FAILED',
        'User login failed.'),
    LOGOUT_FAILED: buildAlert(
        'LOGOUT_FAILED',
        'User logout failed.'),
    LOGIN_EXPIRED: buildAlert(
        'LOGIN_EXPIRED',
        "User login has expired. Please save your work and login again."),
    API_FAILURE: buildAlert(
        'API_FAILURE',
        'Unknown error occurred. Please contact support if you continue to experience issues.'),
    SCANNER_PERMISSION_ERROR: buildAlert(
        'SCANNER_PERMISSION_ERROR',
        'Failed to acquire permission to use camera.'),
    SCANNER_PARSE_ERROR: buildAlert(
        'SCANNER_PARSE_ERROR',
        'Failed to read information from scanned code.'),
    UNKNOWN_SCANNER_FAILURE: buildAlert(
        'UNKNOWN_SCANNER_FAILURE',
        'Unknown camera failure.'),
    INCORRECT_DEVICE_TYPE: buildAlert(
        'INCORRECT_DEVICE_TYPE',
        'Incorrect device type scanned for selection.'),
    INCORRECT_MAC_FORMAT: buildAlert(
        'INCORRECT_MAC_FORMAT',
        'MAC address is incorrectly formatted.'),
    MAC_ADDRESS_IN_USE: buildAlert(
        'MAC_ADDRESS_IN_USE',
        'MAC address already assigned to device.'),
    REINITIATE_FAILED: buildAlert(
        "REINITIATE_FAILED",
        "Reinitiate Provisioning was unsuccessful."
    )
});

export const AppInfo = Object.freeze({
    SUBMIT_COMPLETE: buildAlert(
        'SUBMIT_COMPLETE',
        'Information submitted, see devices for updates and possible errors'
    ),
    REINITIATE_COMPLETE: buildAlert(
        'REINITIATE_COMPLETE',
        'Provisioning reinitiated, see devices for updates and possible errors'
    ),
});

export const withCustomDescription = (appAlert, description) => {
    return {[Object.keys(appAlert)[0]]: description};
};


// WEBPACK FOOTER //
// ./src/constant/appAlerts.js